import { MembershipAwareness } from '../components/MembershipAwareness';
import { useMembershipAwarenessFormData } from '../formContext';
import { useMembershipExists } from '../shared/hooks/useMembershipExists';
import type { Props } from '../shared/types';

export function MembershipAwarenessContainer(props: Props): React.JSX.Element | null {
	const {
		featureConfigs: { membershipEnabled },
	} = useMembershipAwarenessFormData();
	const membershipExists = useMembershipExists();
	if (!membershipEnabled || membershipExists) return null;

	return <MembershipAwareness {...props} />;
}
